export const getters = {
  uiFlags: state => state.uiFlags,
  isFetching: state => state.uiFlags.isFetching,
  entryById: state => id => state.entries.byId[id],
  allEntries: state => state.entries.allIds.map(id => state.entries.byId[id]),
};
